import {
  StreamLanguage,
  type StreamParser,
  type StringStream,
} from "@codemirror/language";

interface X12State {
  lineStart: boolean;
}

const x12Parser: StreamParser<X12State> = {
  startState(): X12State {
    return { lineStart: true };
  },

  token(stream: StringStream, state: X12State): string | null {
    if (stream.eol()) return null;

    // Segment ID at the start of a line (e.g. ISA, GS, ST, BEG, N1)
    if (state.lineStart) {
      state.lineStart = false;
      if (stream.match(/^[A-Z][A-Z0-9]{1,2}/)) {
        return "keyword";
      }
    }

    const ch = stream.peek()!;

    // Segment terminator
    if (ch === "~") {
      stream.next();
      state.lineStart = true;
      return "punctuation";
    }

    // Element separator
    if (ch === "*") {
      stream.next();
      return "punctuation";
    }

    // Component separator
    if (ch === ":") {
      stream.next();
      return "punctuation";
    }

    // Consume data element content up to the next separator or end of line
    let content = "";
    while (!stream.eol()) {
      const c = stream.peek()!;
      if (c === "*" || c === ":" || c === "~") break;
      content += c;
      stream.next();
    }

    // Classify the data element
    if (/^\d+\.?\d*$/.test(content)) {
      return "number";
    }
    return "string";
  },
};

export const x12Language = StreamLanguage.define(x12Parser);
